import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import SynchronizationStatus from "./SynchronizationStatus";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80vw",
  height: "80vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
  borderRadius: 1,
  overflow: "scroll",
};

export default function SynchronizationStatusModal() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Box>
      <Button
        sx={{
          bgcolor: "blue.main",
          color: "white.main",
          textTransform: "none",
          fontWeight: "bold",
          mt: 1,
          "&:hover": {
            bgcolor: "skyBlue.main",
            color: "black.main",
          },
        }}
        onClick={handleOpen}
      >
        View Synchronization Status
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography variant="subtitle1" sx={{ color: "blue.main", mb: 2 }}>
            Synchronization Status
          </Typography>
          <SynchronizationStatus />
        </Box>
      </Modal>
    </Box>
  );
}
